import axios from 'axios';

const TOO_MANY_REQUESTS_STATUS = 429;
const FIRST_SERVER_ERROR_STATUS = 500;

export function isTransientRequestError(caughtError: unknown): boolean {
  if (axios.isAxiosError(caughtError) !== true) {
    return false;
  }
  if (caughtError.response === undefined) {
    return true;
  }
  const status = caughtError.response.status;
  return status === TOO_MANY_REQUESTS_STATUS || status >= FIRST_SERVER_ERROR_STATUS;
}
